import type { Validation } from "@/lib/validation"
import { isStringKeyedRecord } from "@/lib/validation/isStringKeyedRecord"
import { isReferenceContainer } from "@/lib/validation/reference/isContainer"

export const isRecordSchema = <
  Registry extends Validation.BaseRegistry,
  Subject
>(
  api: Validation.API<Registry>,
  expectation: unknown
): expectation is Validation.RecordSchema<Registry, Subject> => {
  if (isReferenceContainer(api, expectation)) {
    return false
  }

  return isStringKeyedRecord(expectation)
}
